/*
 * View for Conversation Variable config
 */

define(["marionette", "./template/conversationVariablesAdminTemplate.html"], function (
  Marionette,
  ConversationVariablesAdminTemplate,
) {
  var ConversationVariablesAdminView = {};

  ConversationVariablesAdminView.conversationVariablesLayout = Marionette.Layout.extend({
    template: ConversationVariablesAdminTemplate,
    regions: {
      list: "#conversationVariableList",
    },
    triggers: {
      "click #addConversationVariable": "add:conversationVariable",
    },
  });

  return ConversationVariablesAdminView;
});
